import { put } from "@redux-saga/core/effects";
import { setStatistics } from "../../reducers/statisticsReducer";
import { LogApi } from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import { handleError } from "../../../util/errorHandler";
import moment from "moment";

function setUpClient() {
  return new LogApi(getAPIConfig(store.getState().settings.internalSettings));
}

export function* handleGetStatistics(action: any): any {
  try {
    const LogClient = setUpClient();
    const response = yield LogClient.getCarePrincipalStatistics(
      action.params.carePrincipalId,
      action.params.dateFrom,
      action.params.dateTo
    );
    response.sort((a: any, b: any) => {
      if (a.fromDate < b.fromDate)
        return -1;
      if (a.fromDate > b.fromDate)
        return 1;
      return 0;
    })
    yield put(setStatistics(response));
  } catch (error) {
    yield handleError(error);
  }
}

export function* handleGetStatisticsCsvFile(action: any): any {
  try {
    const LogClient = setUpClient();
    const response = yield LogClient.getCarePrincipalStatisticsAsCsv(
      action.params.carePrincipalIds,
      action.params.dateFrom,
      action.params.dateTo,
      action.params.column1177
    );
    const FileSaver = require("file-saver");
    const datetime = moment().format("yyyy-MM-YYYY HH:mm:ss");
    const blob = new Blob([response], { type: "text/csv;charset=utf-8" });
    FileSaver.saveAs(blob, "EFK-Statistics " + datetime);
  } catch (error) {
    yield handleError(error);
  }
}
